// Central content for Alley Pub — edit freely.
import {
  UtensilsCrossed,
  Beer,
  Music4,
  Mic2,
  Tv,
} from "lucide-react";

export const BRAND = {
  name: "Alley Pub",
  tagline: "Bellevue's Best Sports Bar & Grill",
  since: 2015,
};

export const CONTACT = {
  address: "7040 Highway 70 South",
  city: "Nashville, TN 37221",
  neighborhood: "Belle Forrest Shopping Center",
  phone: "(615) 662-3990",
  phoneHref: "tel:+16156623990",
  email: "Alleypubgm@gmail.com",
  emailHref: "mailto:Alleypubgm@gmail.com",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=7040+Highway+70+South+Nashville+TN+37221",
};

// No public socials were found for the venue — update these handles anytime.
export const SOCIALS = [
  { label: "Facebook", href: "https://www.facebook.com/AlleyPubNashville", key: "facebook" },
  { label: "Instagram", href: "https://www.instagram.com/alleypubnashville", key: "instagram" },
];

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "What We Offer", id: "offerings" },
  { label: "Menu", id: "menu", route: "/menu" },
  { label: "Our Story", id: "story" },
  { label: "Events", id: "events" },
  { label: "Visit", id: "contact" },
];

export const IMAGES = {
  // Real photos pulled from alleypubnashville.com
  hero: "https://images.squarespace-cdn.com/content/v1/63ed21006eed717e7d7c4c68/fbb457da-ed19-43b4-87a6-f8cb3fc146e3/Alley+Mirror+Pic-min.png?format=1500w",
  wings: "https://images.squarespace-cdn.com/content/v1/63ed21006eed717e7d7c4c68/aedf297c-7903-4ef4-be7c-fa36bd04d839/FC1E382B-682A-446B-9429-2678556A5111.jpeg?format=1000w",
  drinks: "https://images.squarespace-cdn.com/content/v1/63ed21006eed717e7d7c4c68/30c3cc72-d276-4c1a-b9d3-ccab52a772da/D57A4D24-F4BB-48CC-A6C4-61EAF755D5B6.jpg?format=1000w",
  music: "https://images.squarespace-cdn.com/content/v1/63ed21006eed717e7d7c4c68/0dfa8b26-7d60-437d-bc1a-e16c1b2aedfd/37620ECB-AB45-410E-8433-A0DD73F30D74.jpeg?format=1200w",
  karaoke: "https://images.squarespace-cdn.com/content/v1/63ed21006eed717e7d7c4c68/48be56fe-214d-4d66-bade-0cdd029f74f4/karaoke-g7f35fec45_1280-modified.png?format=1000w",
  story: "https://images.squarespace-cdn.com/content/v1/63ed21006eed717e7d7c4c68/93052026-3bc3-4e05-8489-b48f90ddc12f/51556B30-9646-430D-A805-A56E6E6AB01E.jpg?format=1000w",
};

export const OFFERINGS = [
  {
    key: "food",
    icon: UtensilsCrossed,
    title: "The Kitchen",
    blurb:
      "Wings, catfish, burgers, BBQ — real Southern bar food.",
    image: IMAGES.wings,
    span: "md:col-span-2 md:row-span-2",
  },
  {
    key: "drinks",
    icon: Beer,
    title: "Ice-Cold Drinks",
    blurb: "Drafts, wine and cocktails. Happy hour weekdays 2–7.",
    image: IMAGES.drinks,
    span: "md:col-span-2",
  },
  {
    key: "sports",
    icon: Tv,
    title: "Every Game, Every Screen",
    blurb: "HD TVs wall-to-wall. Every game, every screen.",
    image: IMAGES.hero,
    span: "md:col-span-2",
  },
  {
    key: "music",
    icon: Music4,
    title: "Live Music",
    blurb: "Local bands live every Fri & Sat night.",
    image: IMAGES.music,
    span: "md:col-span-2",
  },
  {
    key: "karaoke",
    icon: Mic2,
    title: "Karaoke Thursdays",
    blurb: "Grab the mic. No judgment.",
    image: IMAGES.karaoke,
    span: "md:col-span-2",
  },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "The Vibe",
    body: "Bellevue's living room — where everybody's welcome and the game's always on.",
  },
  {
    no: "02",
    title: "The Food & Drink",
    body: "Wings, catfish, burgers, BBQ and daily specials. Great food, cold drinks, seven days a week.",
  },
  {
    no: "03",
    title: "The Music",
    body: "Live bands Friday & Saturday. Karaoke Thursday. Best seat in Nashville.",
  },
];

export const STATS = [
  { value: 15, suffix: "+", label: "HD TVs" },
  { value: 7, suffix: " days", label: "Of Specials" },
  { value: 3, prefix: "$", label: "Domestic Beers" },
  { value: 19, suffix: "yrs", label: "In Bellevue" },
];

export const EVENTS = [
  {
    day: "Mon – Fri",
    title: "Happy Hour",
    detail: "$3 Domestic Beers & $4 Wine",
    time: "2 – 7 PM",
  },
  {
    day: "Tuesday",
    title: "Poker Night",
    detail: "Free to play",
    time: "7 PM",
  },
  {
    day: "Wednesday",
    title: "Jukebox Bingo",
    detail: "Play & win",
    time: "7 PM",
  },
  {
    day: "Thursday",
    title: "Karaoke Night",
    detail: "Sing your heart out",
    time: "8 PM",
  },
  {
    day: "Fri & Sat",
    title: "Live Music",
    detail: "Local bands, live on stage",
    time: "Evenings",
  },
  {
    day: "Sunday",
    title: "Bloody Mary & Mimosa Bar",
    detail: "Build your own — until 3 PM",
    time: "Sun Brunch",
  },
];

export const MARQUEE_ITEMS = [
  "Live Music Fri & Sat",
  "Karaoke Thursdays",
  "Happy Hour Mon–Fri 2–7",
  "Sunday Draft Specials",
  "Smoked Wings Mondays",
  "Catch Every Game",
];

export const TESTIMONIALS = [
  {
    quote:
      "Best neighborhood bar in Bellevue. Cold beer, every game on.",
    name: "Marcus T.",
    role: "Regular",
  },
  {
    quote:
      "Karaoke nights are a blast and the burgers are underrated.",
    name: "Danielle R.",
    role: "Karaoke MVP",
  },
  {
    quote:
      "Best live music in Bellevue and the wings are unreal.",
    name: "Chris & Amy",
    role: "Weekend regulars",
  },
  {
    quote:
      "Unbeatable happy hour and TVs everywhere — our game day spot.",
    name: "Jordan P.",
    role: "Game day crew",
  },
];

export const HOURS = [
  { day: "Mon – Thu", time: "11 AM – 2 AM" },
  { day: "Friday", time: "11 AM – 3 AM" },
  { day: "Saturday", time: "10:30 AM – 3 AM" },
  { day: "Sunday", time: "10:30 AM – 2 AM" },
];
